import './App.css';
import Layout from './Layout/Layout';
import React from 'react';
import DisableRightClick from './components/DisableRightClick/DisableRightClick';
function App() {

  return(
    <>
    <Layout />
    <DisableRightClick />
    </>
  );
}

export default App;
